import { AdminModalName, HistoryStack } from '../../state';
import { ADMIN_MODALS_HISTORY_ACTION_TYPE_PREFIX } from '../../actions';
import { createHistoryStackReducer } from '../history-stack';

/**
 * Initial history stack state that has an empty entries array.
 */
const initialState: HistoryStack<AdminModalName> = {
  entries: [],
  index: -1,
  lastAction: null,
};

export const adminModalsReducer = createHistoryStackReducer(
  ADMIN_MODALS_HISTORY_ACTION_TYPE_PREFIX,
  initialState,
);
